module.exports = __webpack_public_path__ + "static/media/linkedin.dbc9511c.png";